import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidWordPath } from '../../../../mechanics/rid-word-path/rid-word-path';

@Component({
  selector: 'app-word-path-page',
  imports: [RidWordPath],
  templateUrl: './word-path-page.html',
})
export class WordPathPage {
  protected readonly $router = inject(Router);
}
